var _rect, _path, _path2, _circle, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 28,
    viewBox: "0 0 55 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 28,
    rx: 6,
    fill: "#3974FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.521 18.6667C19.7195 18.3235 19.8331 17.9251 19.8331 17.5001V16.9167C19.8331 16.2601 19.6162 15.6542 19.25 15.1667H20.9165C21.8829 15.1667 22.6664 15.9502 22.6665 16.9167V16.9167V17.5V17.5001C22.6665 18.1444 22.1441 18.6667 21.4998 18.6667H20.9165H19.521Z",
    fill: "#3974FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8506 13.6978C17.2594 13.1251 17.4999 12.4239 17.4999 11.6667C17.4999 10.9094 17.2594 10.2083 16.8506 9.63554C17.1898 9.44316 17.582 9.33333 17.9999 9.33333C19.2886 9.33333 20.3332 10.378 20.3332 11.6667C20.3332 12.9553 19.2886 14 17.9999 14C17.582 14 17.1898 13.8902 16.8506 13.6978Z",
    fill: "#3974FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0001,
    cy: 11.6667,
    r: 2.33333,
    fill: "#3974FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6666 16.9408C18.6667 16.9328 18.6667 16.9247 18.6667 16.9167C18.6667 15.9502 17.8832 15.1667 16.9167 15.1667H11.0834V15.1668C10.117 15.1668 9.33367 15.9502 9.33358 16.9166H9.33325V17.4999H9.33341C9.33341 17.5 9.33341 17.5 9.33341 17.5C9.33341 18.1443 9.85575 18.6667 10.5001 18.6667H11.0666L11.0836 18.6668L11.1006 18.6667H16.9167H17.5001C18.1444 18.6667 18.6667 18.1443 18.6667 17.5C18.6667 17.4934 18.6667 17.4869 18.6666 17.4803V16.9408Z",
    fill: "#3974FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0063 9.48047H27.6V10.5352H33.7055V10.6758C33.7055 12.0527 33.7055 13.5879 33.2953 15.668L34.6195 15.7852C35.0063 13.5527 35.0063 12.0938 35.0063 10.6758V9.48047ZM26.5805 17.5898H36.2367V16.5234H26.5805V17.5898ZM46.4195 13.6172H36.7398V14.6484H40.9234V15.7031H42.2125V14.6484H46.4195V13.6172ZM37.9352 9.62109H43.9234V10.3242H37.9703V12.9727H45.4352V12H39.2594V11.25H45.2242V8.63672H37.9352V9.62109ZM37.982 18.9141H45.2359V15.1875H43.9469V16.1484H39.2711V15.1875H37.982V18.9141ZM39.2711 17.918V17.1211H43.9469V17.918H39.2711Z",
    fill: "#3974FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityGroupIcon);
export default __webpack_public_path__ + "static/media/community_group_icon.259c56c03b9ca808ae8b3e4c880b6d89.svg";
export { ForwardRef as ReactComponent };